import { useLocation } from 'react-router-dom';
import useDocumentTitle from '../../../shared/hooks/useDocumentTitle';

const DocumentTitle = () => {
  const location = useLocation();

  // Define page titles based on route
  const getPageTitle = (pathname: string): string => {
    const baseTitle = 'OCBD Bogor';

    switch (pathname) {
      case '/':
      case '/home':
        return 'OCBD BOGOR – Kawasan Perumahan Strategis di Kota';
      case '/facilities':
        return `Facilities - ${baseTitle}`;
      case '/promo':
        return `Promo - ${baseTitle}`;
      case '/about-us':
        return `Tentang Kami - ${baseTitle}`;
      case '/projects/residence/pine-garden':
        return `Pine Garden - ${baseTitle}`;
      case '/projects/residence/virginia-pine':
        return `Virginia Pine - ${baseTitle}`;
      case '/projects/residence/northern-pine':
        return `Northern Pine - ${baseTitle}`;
      case '/projects/residence/morizora':
        return `Morizora - ${baseTitle}`;
      case '/projects/commercial':
        return `Commercial District - ${baseTitle}`;
      case '/news':
        return `Berita - ${baseTitle}`;
      default:
        return 'OCBD BOGOR – Kawasan Perumahan Strategis di Kota';
    }
  };

  const pageTitle = getPageTitle(location.pathname);
  useDocumentTitle(pageTitle);

  return null; // This component doesn't render anything
};

export default DocumentTitle;
